module.exports = __webpack_public_path__ + "static/img/door-gf1.965b1ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/door-gf/door-gf1.jpg
// module id = 73xA
// module chunks = 0